<template>
    <transition
        enter-class="opacity-0"
        enter-active-class="transition-opacity duration-300 ease-out"
        enter-to-class="opacity-100"
        leave-class="opacity-100"
        leave-active-class="transition-opacity duration-300 ease-out"
        leave-to-class="opacity-0"
        name="fade-in-out"
        mode="out-in"
    >
        <slot></slot>
    </transition>
</template>

<script>
import { gsap } from "gsap";

export default {
    props: ["mode", "speed"],

    data() {
        return {
            dataSpeed: this.speed ? this.speed : .4,
            dataMode: this.mode ? this.mode : 'out-in',
        }
    },

    methods: {
        enter(el, done) {
            gsap.set(el, {opacity:1})
            gsap.from(el, this.dataSpeed, {opacity: 0, onComplete: done});
        },

        leave(el, done) {
            gsap.to(el, this.dataSpeed, {opacity: 0, onComplete: done});
        },
    }
}
</script>
<style>
/*    .slide-down-enter-active, .slide-down-leave-active {
        overflow:hidden;
    }*/
</style>
